import { BaSeTheme } from '@base/react';
import styled from 'styled-components';

const handleQuery = (style) => {
  return `
    ${BaSeTheme.breakpoints.mobileLarge.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobile.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobileSmall.mediaQueryCss(style)};
  `;
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 650px;
  width: 100%;
  padding-bottom: 20px;
  gap: 25px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 4px;

  background: ${BaSeTheme.colors.defaultColors.white};
  border: 1px solid ${BaSeTheme.colors.institucionais.cinzaSebrae90};
  gap: 16px;
  padding-bottom: 8px;
  width: 100%;

  ${handleQuery(`
   width: 90%;
  `)}
`;
export const ContentItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  gap: 8px;
  margin-top: 12px;
  padding: 0 20px;
`;

export const ContentText = styled.div`
  margin-top: 12px;
  padding: 0 20px;
  gap: 8px;
`;
